var _ClipboardManager_clipboardImageParser;
import { __classPrivateFieldGet } from "tslib";
import Axios from 'axios';
import { ClipboardImageParser } from './ClipboardImageParser';
export class ClipboardManager {
    constructor() {
        _ClipboardManager_clipboardImageParser.set(this, new ClipboardImageParser());
    }
    uploadImageCache(rawData, callback) {
        const file = __classPrivateFieldGet(this, _ClipboardManager_clipboardImageParser, "f").parseImageFile(rawData);
        if (file === null) {
            return false;
        }
        this.uploadImageCacheWithFile(file, (imageUri) => {
            callback(imageUri);
        });
        return true;
    }
    uploadImageCacheWithUrl(rawData, callback) {
        __classPrivateFieldGet(this, _ClipboardManager_clipboardImageParser, "f").parseImageUrl(rawData, (uri) => {
            if (uri !== null) {
                callback(uri);
            }
        });
    }
    uploadImageCacheWithFile(file, callback) {
        const formData = new FormData();
        formData.append('image', file);
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };
        Axios.post('https://mycast.xyz:8002/cache', formData, config).then((res) => {
            if (res.status !== 200 || !res.data) {
                return;
            }
            const imageUri = res.data;
            callback(imageUri);
        });
    }
}
_ClipboardManager_clipboardImageParser = new WeakMap();
